import { useEffect, useState } from "react";
import { Wifi, WifiOff } from "lucide-react";
import { toast } from "sonner";

export function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        toast.success("You're back online", {
          icon: <Wifi className="w-4 h-4" />,
          description: "Your connection has been restored.",
        });
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      toast.error("You're offline", {
        icon: <WifiOff className="w-4 h-4" />,
        description: "Please check your internet connection.",
        duration: Infinity,
        id: "offline-toast",
      });
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [wasOffline]);

  // Dismiss the offline toast when back online
  useEffect(() => {
    if (isOnline) {
      toast.dismiss("offline-toast");
    }
  }, [isOnline]);

  return null;
}
